<template>
    <div class="relative group">
        <a class="flex items-center p-2 bg-secondary-100 mb-2" :href="line.url">
            <div class="mr-4">
                <div class="block w-14 aspect-1:1 bg-cover bg-center lazyload" :data-bg="line.image"></div>
            </div>

            <div class="flex-1">
                <div class="text-sm">{{ line.description }}</div>

                <ul v-if="line.adjustments.length" class="text-xs mt-2">
                    <li v-for="adjustment in line.adjustments" :key="adjustment.id">
                        {{ adjustment.name }}: <MoneyFormat :amount="adjustment.amount" />
                    </li>
                </ul>
            </div>

            <div class="px-2 text-sm text-right font-bold group-hover:opacity-0" :class="{ 'opacity-0': loading }">
                <div><MoneyFormat :amount="line.total" /></div>
                <div v-if="line.quantity > 1">&times; {{ line.quantity }}</div>
            </div>
        </a>

        <button
            class="group-hover:block absolute right-0 align-y mr-4 w-6 h-6 font-light text-2xl leading-none"
            :class="{ loading, hidden: !loading }"
            @click.prevent="onDeleteLine(line)"
        >
            &times;
        </button>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MoneyFormat from '../MoneyFormat.vue';
const { mapActions } = createNamespacedHelpers('cart');

export default {

    components: {
        MoneyFormat,
    },
    props: {
        line: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        ...mapActions([
            'removeFromCart',
        ]),

        async onDeleteLine(line) {
            this.loading = true;

            await this.removeFromCart(line.variantId);

            this.loading = false;
        },
    },
};
</script>
